import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import WidgetBox, { Props as WidgetBoxProps } from '@wix/da-gruser-shared/pkg/components/WidgetBox';
import SubscriptionCenter from './SubscriptionCenter';
import { isCurrentUserProfileOwner } from '../../../../../selectors/users';
import ManagementDropdown from '../../../../shared/ManagementDropdown';

import s from './SubscriptionCenterBox.scss';

interface Props {
  moduleId: number;
  widgetBoxProps?: Partial<WidgetBoxProps>;
}

const SubscriptionCenterBox: FC<Props> = ({ moduleId }) => {
  const { t } = useTranslation();
  const isOwner = useSelector(isCurrentUserProfileOwner);

  const headerNode = (
    <div className={s['header-with-actions']}>
      <span>{t('widgets.subscription_center.header')}</span>
      {isOwner && <ManagementDropdown className={s['management-dropdown']} type="subscriptions" />}
    </div>
  );

  return (
    <WidgetBox moduleId={moduleId} header={headerNode} className={s['root']}>
      <SubscriptionCenter moduleId={moduleId} className={s['subscription-center']} />
    </WidgetBox>
  );
};

SubscriptionCenterBox.displayName = 'SubscriptionCenterBox';
export default SubscriptionCenterBox;
